var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 32 32","fill":"none"}},[_c('path',{attrs:{"d":"M12.4997 24L11.0664 22.5667L17.6664 15.9667L11.0664 9.36668L12.4997 7.93335L20.5331 15.9667L12.4997 24Z","fill":_vm.color,"fill-opacity":"0.38"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }